export default __webpack_public_path__ + "static/media/sp-ads.d540c05b.png";